<template>
  <div class="combobox-rental-dispense-display">
    <ComboboxRentalMutationBaseDisplay
      :item="item"
      :instruction="instruction"
      :flow-direction="flowDirection"
      :is-list-item="isListItem"
      :is-being-updated="isBeingUpdated"
      :show-date="showDate"
      :show-project="showProject"
      :show-badge="showBadge"
      :show-counter-booking="showCounterBooking"
      :show-error="showError"
      :error="error"
      @clear-error="$emit('clearError')"
    >
      <ComboboxRentalDispenseItemInfo :rental-dispense-item="rentalDispense.rentalDispenseItem" />
      <div v-if="rentalDispense.counterMutation?.adminComment" class="italic">
        <FontAwesomeIcon :icon="['fas', 'comment']" class="mr-0.5" />
        <span v-if="rentalDispense.isReturn()" class="text-xs">(uitgifte)</span>
        {{ rentalDispense.counterMutation.adminComment }}
      </div>
      <div v-if="rentalDispense.adminComment" class="italic">
        <FontAwesomeIcon :icon="['fas', 'comment']" class="mr-0.5" />
        <span v-if="rentalDispense.isReturn()" class="text-xs">(retour)</span>
        {{ rentalDispense.adminComment }}
      </div>
    </ComboboxRentalMutationBaseDisplay>
  </div>
</template>

<script setup lang="ts">
import { RentalDispense } from "@/models/rental-dispense.model"
import { computed, inject } from "vue"
import ComboboxRentalDispenseItemInfo from "@/components/administration/combobox-display-templates/basic/ComboboxRentalDispenseItemInfo.vue"
import { Instruction } from "@/models/instruction.model"
import ComboboxRentalMutationBaseDisplay from "@/components/administration/combobox-display-templates/nested/ComboboxRentalMutationBaseDisplay.vue"
import { BaseException } from "@/exceptions/base-exception.exception"
import { RentalMutationFlowDirections } from "@/enums/rental-mutation-flow-directions"

const props = defineProps<{
  item: RentalDispense | [RentalDispense]
  flowDirection: RentalMutationFlowDirections
  isListItem: boolean
  isBeingUpdated: boolean
  showDate?: boolean
  showProject?: boolean
  showBadge?: boolean
  showCounterBooking?: boolean
  showError?: boolean
  error?: BaseException
}>()

const rentalDispense = computed(() => {
  if (props.item instanceof RentalDispense) {
    return props.item
  }
  return props.item[0]
})

const instruction = inject<Instruction>("instruction")!
if (!instruction) {
  throw new Error("Instruction is required")
}
</script>

<style scoped></style>
